import { List, Record } from 'immutable'
import { AssociatedProperty, IAssociatedProperty } from './AssociatedProperty'
import { ISignTransfer, SignTransfer } from './SignTransfer'
import { ISignType, SignType } from './SignType'

export interface ISign {
  readonly id: string
  readonly notes: string
  readonly pendingTransfers: List<ISignTransfer>
  readonly property: IAssociatedProperty
  readonly quantity: number
  readonly signType: ISignType
}

const SignRecord = Record({
  id: '',
  notes: '',
  pendingTransfers: List<SignTransfer>(),
  property: new AssociatedProperty(),
  quantity: 0,
  signType: new SignType(),
})

export class Sign extends SignRecord implements ISign {
  public static fromJS(initialState?: any) {
    if (!initialState) {
      return new Sign()
    }

    const { pendingTransfers, property, signType, ...rest } = initialState

    return new Sign({
      pendingTransfers: pendingTransfers
        ? List(pendingTransfers.map((t: any) => SignTransfer.fromJS(t)))
        : List<SignTransfer>(),
      property: AssociatedProperty.fromJS(property),
      signType: SignType.fromJS(signType),
      ...rest,
    })
  }

  public readonly id: string
  public readonly notes: string
  public readonly pendingTransfers: List<SignTransfer>
  public readonly property: AssociatedProperty
  public readonly quantity: number
  public readonly signType: SignType

  constructor(props?: Partial<Sign>) {
    props ? super(props) : super()
  }
}
